import { orderList } from '@/composables/useOrderPage'

const getPaymentMode = () => {
  const route = useRoute();
  return (route.query.mode as string) ?? 'direct'
};

export const couponPrice = ref<number>(0); // 쿠폰금액
export const couponCount = ref<number>(0); // 쿠폰개수
export const useCouponList = ref<Record<string, any>>({});
export const showUseCouponList = ref<Record<string, any>[]>([]);
export const goodsCouponInfos = ref<Record<string, any>[]>([]);
export const goodsCouponCount = ref<number>(0);
export const findNotUseAbleCoupon = ref<number>(0); //적립금불가상품의 쿠폰금액
export const shippingCouponList = ref<Record<string, any>[]>([]);
export const shippingCouponCount = ref<number>(0);
export const shippingCouponPrice = ref<number>(0);
export const selectedShippingCoupon = ref<Record<string,any>>({});  // 선택된 배송쿠폰
export const selectedShippingCouponSeq = ref<number>(0); // 선택된 배송쿠폰 seq

/**
 *  쿠폰 데이터 초기화
 */
const initValue = () => {
  couponPrice.value = 0; // 쿠폰금액
  couponCount.value = 0; // 쿠폰개수
  useCouponList.value = {}; // 사용된 쿠폰리스트
  showUseCouponList.value.length = 0; // 보여지는 쿠폰리스트
  goodsCouponInfos.value.length = 0; // 상품쿠폰리스트
  goodsCouponCount.value = 0; // 상품쿠폰 개수
  findNotUseAbleCoupon.value = 0; //적립금불가상품의 쿠폰금액
  shippingCouponList.value.length = 0; // 배송비쿠폰리스트
  shippingCouponCount.value = 0; // 배송비쿠폰 개수
  shippingCouponPrice.value = 0; // 배송비쿠폰 금액
  selectedShippingCoupon.value = {}; // 선택된 배송쿠폰
  selectedShippingCouponSeq.value = 0; // 선택된 배송쿠폰 seq
}

/**
 * 쿠폰 리스트조회
 */
export const getCouponList = async () => {
  const { $sendPost } = useNuxtApp();
  const rootStore = useRootStore();
  let paymentMode = getPaymentMode();

  if(isNotCurrentPage()){
    return 
  }

  const data = {
    mode: paymentMode,
    goodsSeqList: orderList.value.map((item) => { return item.goodsSeq }),
    cartOptionSeqList: orderList.value.map((item) => { return item.cartOptionSeq })
  }
  const result = await $sendPost({
    url: `${getStoreApiUrl('coupon', '','/l1')}/availableCoupons/${paymentMode}`,
    data: data,
    showDefaultLoading: false
  })
  if (result.data?.RESULT_CODE === '0') {
    goodsCouponInfos.value = result.data?.DATA?.coupon?.goodsCouponInfos ?? {}
    goodsCouponCount.value = result.data?.DATA?.coupon?.goodsCouponSize
    shippingCouponList.value = result.data?.DATA?.coupon?.shippingCouponList ?? []
    shippingCouponCount.value = result.data?.DATA?.coupon?.shippingCouponList?.length ?? 0

     //쿠폰 이름이 [복원]이 여러개인 경우 처리
     if (Array.isArray(goodsCouponInfos.value)) {
      goodsCouponInfos.value.forEach((couponInfo) => {
        if (couponInfo.myCouponList) {
          couponInfo.myCouponList = couponInfo.myCouponList.map((coupon: any) => ({
            ...coupon,
            couponName: coupon.couponName.replace(/^(\[복원\]\s*)+/, '[복원] '),
          }));
        }
      });
    } 
    console.log('goodsCouponInfos.value::::::::::::::', goodsCouponInfos.value);

    //쿠폰할인 초기 세팅
    couponInitSet();
  } else {
    rootStore.toast(getErrorMessage(result.data?.RESULT_CODE ?? ''));
  }
};

/**
 * 쿠폰할인가 초기 셋팅 - 제일 할인이 높은금액 셋팅
 * @param orderList 
 * @param goodsCouponInfos 
 * @param showUseCouponList 
 * @param useCouponList 
 * @returns 
 */
export const couponInitSet = () => {
  //화면유입에 따라 초기화작업
  couponCount.value = 0
  couponPrice.value = 0
  showUseCouponList.value.length = 0

  // 카트옵션별로 정리된 쿠폰목록을 allCouponList에 모두 저장
  const allCouponList: Record<string, any>[] = [];
 
  orderList.value.forEach(item => {
    const couponDataItem = Object.keys(goodsCouponInfos.value).length === 0   ? null : 
     goodsCouponInfos.value.find((coupon: Record<string, any>) => coupon.cartOptionSeq === item.cartOptionSeq);
    if (couponDataItem && couponDataItem.myCouponList && couponDataItem.myCouponList.length > 0) {
      couponDataItem.myCouponList.forEach((coupon: Record<string, any>) => {
        coupon.cartOptionSeq = item.cartOptionSeq; // cartOptionSeq 추가
        allCouponList.push(coupon); // 쿠폰을 allCouponList에 추가

        if (coupon.exchangeGoodsCouponQuantity && coupon.exchangeGoodsCouponQuantity != 0) {
          coupon.applyCount = Math.min(coupon.exchangeGoodsCouponQuantity, item.quantity);
        }
      });
    }
  });

  if (allCouponList.length === 0) {
    return false
  }

  // 전체쿠폰을 할인금액이 제일 높은순으로 정렬
  const sortedArray = allCouponList.sort((a, b) => b.couponSaleAmount - a.couponSaleAmount);
  // cartOptionSeq 중복 및 couponIssuanceSeq 중복 시 중복을 방지하기 위한 Set
  const uniqueCartOptionSeqSet = new Set();
  const uniqueDownloadSeqSet = new Set();

  // 중복을 방지하면서 큰 값으로 셋팅된 배열
  const resultArray = sortedArray.map(coupon => {
    if (!uniqueCartOptionSeqSet.has(coupon.cartOptionSeq) && !uniqueDownloadSeqSet.has(coupon.couponIssuanceSeq)) {
      uniqueCartOptionSeqSet.add(coupon.cartOptionSeq);
      uniqueDownloadSeqSet.add(coupon.couponIssuanceSeq);
      return { ...coupon }; // 새로운 객체를 생성하여 순환 참조 오류 회피
    } else {
      // 중복된 경우에는 큰 값을 설정
      const existingCoupon = sortedArray.find(existing => existing.cartOptionSeq === coupon.cartOptionSeq || existing.couponIssuanceSeq === coupon.couponIssuanceSeq);
      if (existingCoupon && existingCoupon.couponSaleAmount < coupon.couponSaleAmount) {
        existingCoupon.couponSaleAmount = coupon.couponSaleAmount;
      }
      return null; // 중복된 항목은 제거
    }
  }).filter(Boolean);

  // ========= TOBE 리뉴얼 : 단독쿠폰 삭제 ==============
  // 더 큰 할인 금액을 가진 쿠폰 찾기
  // const couponWithHighestDiscount = resultArray.reduce((prev: any, current: any) => {
  //   return (prev.couponSaleAmount > current.couponSaleAmount) ? prev : current;
  // });

  // if (couponWithHighestDiscount && !couponWithHighestDiscount.duplicateUseYn) {
  //   showUseCouponList.push(couponWithHighestDiscount);
  // } else {
  //   const sameTimeCoupons = resultArray.filter((item: any) => item.duplicateUseYn)
  //   if (sameTimeCoupons.length > 0) {
  //     showUseCouponList = sameTimeCoupons.map(coupon => ({ ...coupon }));  // 중복사용가능 쿠폰의 경우
  //   } else {
  //     showUseCouponList.push(resultArray[0] ?? []) // 중복사용 불가능 쿠폰의 경우 가장 할인이 큰 첫번째 index를 세팅
  //   }
  // }
  // if (couponWithHighestDiscount ) {
  // }

  showUseCouponList.value.length = 0;
  showUseCouponList.value.push(...resultArray.map(coupon => ({ ...coupon })));

  //쿠폰 개수
  couponCount.value = showUseCouponList.value.reduce((total, coupon) => {
    if (coupon.isExchangeGoodsCoupon) {
      return total + (coupon.applyCount || 1); // applyCount가 없을 경우 기본값 1
    } else {
      return total + 1;
    }
  }, 0);

  orderList.value.map(order => {
    const matchedCoupon = showUseCouponList.value.find(
      coupon => order.cartOptionSeq === coupon.cartOptionSeq
    );

    if (matchedCoupon) {
      order.useCouponSeq = matchedCoupon.couponIssuanceSeq,
        order.couponSaleAmount = matchedCoupon.couponSaleAmount || '',
        order.isExchangeGoodsCoupon = matchedCoupon.isExchangeGoodsCoupon || false,
        order.exchangeGoodsCouponQuantity = matchedCoupon.applyCount || 0, // 쿠폰이 적용되는 수량 (초기값)
        order.exchangeGoodsCouponIssuanceList = matchedCoupon.exchangeGoodsCouponIssuanceList || [],
        order.selectedPointCount = matchedCoupon.applyCount || 1 // 기본적으로 최대 갯수로 설정
    } else {
      order.useCouponSeq = '',
        order.couponSaleAmount = '',
        order.isExchangeGoodsCoupon = false,
        order.exchangeGoodsCouponQuantity = 0,
        order.exchangeGoodsCouponIssuanceList = [],
        order.selectedPointCount = null
    }
  });

  // 진짜로 사용된 쿠폰 번호와 쿠폰 가격 세팅
  useCouponList.value = {} //초기화
  showUseCouponList.value.forEach(item => {
    useCouponList.value[item.cartOptionSeq] = item.couponIssuanceSeq;
    couponPrice.value += item.isExchangeGoodsCoupon ? (item.couponSaleAmount * item.applyCount) : item.couponSaleAmount;
  });

  //적립금 불가 상품의 쿠폰금액찾기
  let findNotUseAbleEmoney = orderList.value.filter(item => item.useEmoneyYn === false);
  findNotUseAbleCoupon.value = findNotUseAbleEmoney.reduce((sum, item) => {
    let coupon = showUseCouponList.value.find(coupon => coupon.cartOptionSeq === item.cartOptionSeq);
    return coupon ? sum + coupon.couponSaleAmount : sum;
  }, 0);

  console.log('적립금 사용 불가한 상품의 쿠폰 금액:', findNotUseAbleCoupon.value);

};

/**
 * 사용된 쿠폰리스트를  상품쿠폰리스트 request로 세팅
 * useCouponList => goodsCouponList
 */
export const setGoodsCouponListRequest = ()=>{
  const cartOptionUsableCoupons :Record<string,any> = [];
  for (const [key, value] of Object.entries(useCouponList.value)) {
    if (value) {
      const orderItem = orderList.value.find(order => order.cartOptionSeq === parseInt(key));

      if (orderItem && orderItem.isExchangeGoodsCoupon && orderItem.selectedPointCount) {
        // selectedPointCount만큼 couponIssuanceSeqList에 추가
        const couponIssuanceSeqList = orderItem.exchangeGoodsCouponIssuanceList.slice(0, orderItem.selectedPointCount);

        cartOptionUsableCoupons.push({
          cartOptionSeq: parseInt(key),
          goodsIssuanceCouponSeq: couponIssuanceSeqList
        });
      } else {
        // 일반 쿠폰 사용의 경우
        cartOptionUsableCoupons.push({
          cartOptionSeq: parseInt(key),
          goodsIssuanceCouponSeq: [value]  // 일반 쿠폰은 단일 goodsIssuanceCouponSeq로 처리
        });
      }
    }
  }
  return cartOptionUsableCoupons
}


/**
 * 배송비쿠폰 초기세팅
 * 배송비쿠폰이 있는경우 배송비쿠폰리스트에서 제일 할인금액이 큰 쿠폰을 선택
 * 1순위 : 배송비쿠폰이 무료배송인 경우 
 * 2순위 : 배송비쿠폰이 할인금액이 제일 큰 쿠폰
 */
export const shippingCouponInitSet = () => {
  shippingCouponPrice.value = 0

  const getBestShippingCoupon = () => {
    // 1순위: deliveryDiscountType이 'FREE'인 쿠폰 중 가장 먼저 있는 것
    const freeCoupon = shippingCouponList.value.find(item => item.deliveryDiscountType === 'FREE');
    if (freeCoupon) return freeCoupon;

    // 2순위: discountPrice가 가장 큰 쿠폰
    const maxDiscountCoupon = shippingCouponList.value.reduce((best, current)  => {
      return current.discountPrice > (best.discountPrice || 0) ? current : best;
    }, {} as Record<string, any>);

    return maxDiscountCoupon;
  }

  selectedShippingCoupon.value =  getBestShippingCoupon()
  selectedShippingCouponSeq.value = selectedShippingCoupon.value.couponIssuanceSeq || 0; // 선택된 배송쿠폰 seq
}